// Tipos base que no renderizan ningún input editable: no aplica avisar sobre
// config_tabla/config_columna porque no hay campo del que el usuario pueda esperar que se guarde.
const TIPOS_SIN_INPUT_EDITABLE = ['note', 'geopoint'];

const esValorConfigurado = (valor) => {
  if (valor === null || valor === undefined) return false;
  const texto = String(valor).trim();
  return texto !== '' && texto.toUpperCase() !== 'NULL';
};

/**
 * Determina si la pregunta tiene a dónde guardar su valor: config_tabla/config_columna (MySQL)
 * o, en fichas Miel, el documento de Mongo (`guardado_mongo`, lo marca la API). Sin ninguno
 * el valor nunca se persiste aunque el campo se muestre y se pueda escribir en él.
 * @param {object} question - La pregunta completa
 * @returns {boolean}
 */
export const tieneDestinoDeGuardado = (question) =>
  (esValorConfigurado(question?.config_tabla) && esValorConfigurado(question?.config_columna)) ||
  question?.guardado_mongo === true;

/**
 * true si la pregunta debería mostrarse bloqueada + con aviso porque, aunque tiene un input
 * editable, no tiene dónde guardarse (config_tabla/config_columna vacíos).
 * @param {object} question - La pregunta completa
 * @returns {boolean}
 */
export const sinDestinoDeGuardado = (question) => {
  const tipoBase = (question?.type || '').split(' ')[0];
  if (TIPOS_SIN_INPUT_EDITABLE.includes(tipoBase)) return false;
  return !tieneDestinoDeGuardado(question);
};

export const TEXTO_SIN_DESTINO = 'Este campo no se guarda: no tiene una tabla/columna configurada en el sistema (config_tabla/config_columna vacíos)';
